import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NumInput from './NumInput';
import { currencySymbol } from '../../utils/region';

// Per-line discount input that supports BOTH a percent of (qty × unit price) and a flat THB amount —
// like Peak. A small "%/฿" toggle opens a "Discount model" popup; the pre-VAT + subtotal recompute live
// in the parent (which resolves the percent into THB). Switching mode resets the value to 0.
export default function DiscountInput({ isPct, value, onChange, cellStyle, companyId }: {
  isPct: boolean; value: number; onChange: (isPct: boolean, value: number) => void; cellStyle: React.CSSProperties;
  companyId?: string | null;   // the document's company — its currency symbol on the toggle
}) {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState<{ left: number; top: number; width: number } | null>(null);
  const sym = currencySymbol(companyId) || '¤'; // generic currency sign until the region has a symbol
  const openPopup = () => { if (ref.current) { const r = ref.current.getBoundingClientRect(); setRect({ left: r.left, top: r.bottom + 3, width: Math.max(r.width, 160) }); } setOpen(true); };

  return (
    <div ref={ref} style={{ position: 'relative', width: 70 }}>
      <div style={{ ...cellStyle, display: 'flex', alignItems: 'center', padding: 0, overflow: 'hidden' }}>
        <NumInput value={value} onChange={n => onChange(isPct, n)}
          style={{ flex: 1, minWidth: 0, border: 'none', background: 'transparent', textAlign: 'right', fontSize: 13, color: 'var(--text-primary)', outline: 'none', padding: '7px 1px 7px 6px', boxSizing: 'border-box' }} />
        <span onClick={openPopup} title={t('iv_disc_model')}
          style={{ cursor: 'pointer', padding: '0 6px', color: isPct ? 'var(--accent)' : 'var(--text-tertiary)', fontWeight: 800, fontSize: 12 }}>{isPct ? '%' : sym}</span>
      </div>
      {open && rect && (
        <>
          <div onMouseDown={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 10049 }} />
          <div style={{ position: 'fixed', left: rect.left, top: rect.top, width: rect.width, zIndex: 10050, background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 9, boxShadow: 'var(--shadow-md)', padding: '10px 13px' }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: 'var(--text-secondary)', marginBottom: 8 }}>{t('iv_disc_model')}</div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 9, fontSize: 13, padding: '5px 0', cursor: 'pointer', color: 'var(--text-primary)' }}>
              <input type="radio" checked={isPct} onChange={() => { onChange(true, 0); setOpen(false); }} />{t('iv_disc_percent')}
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 9, fontSize: 13, padding: '5px 0', cursor: 'pointer', color: 'var(--text-primary)' }}>
              <input type="radio" checked={!isPct} onChange={() => { onChange(false, 0); setOpen(false); }} />{t('iv_disc_thb')}
            </label>
          </div>
        </>
      )}
    </div>
  );
}
